import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MonitorIcon, SmartphoneIcon, MaximizeIcon, XIcon } from "lucide-react";
import { DemoSite } from "./DemoSite";
import { trackEvent } from "../../utils/analytics";
type Mode = "desktop" | "mobile";
export function DemoViewer() {
  const [mode, setMode] = useState<Mode>("desktop");
  const [full, setFull] = useState(false);
  useEffect(() => {
    if (!full) return;
    document.body.style.overflow = "hidden";
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setFull(false);
    document.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKey);
    };
  }, [full]);
  const btn = (active: boolean) => `inline-flex min-h-[44px] items-center gap-2 rounded-full px-4 text-[15px] transition-colors duration-150 ease-out ${active ? "bg-fg text-ink" : "text-fg-2 hover:text-fg"}`;
  const choose = (m: Mode) => {
    setMode(m);
    trackEvent("demo_toggle", {
      mode: m
    });
  };
  return <div data-id="element-95" data-mp="uh1jrekq99lp">
      <div role="toolbar" aria-label="Preview size" className="mb-6 inline-flex flex-wrap gap-1 rounded-full border border-line bg-ink-2 p-1" data-id="element-96" data-mp="uhb86xq4j8pa">
        <button type="button" aria-pressed={mode === "desktop"} onClick={() => choose("desktop")} className={btn(mode === "desktop")} data-id="element-97" data-mp="pkkirjsfj0r7">
          <MonitorIcon className="h-4 w-4" data-id="element-98" data-mp="1i6vtvodnwk29" /> Desktop
        </button>
        <button type="button" aria-pressed={mode === "mobile"} onClick={() => choose("mobile")} className={btn(mode === "mobile")} data-id="element-99" data-mp="1i986rn4kc48g">
          <SmartphoneIcon className="h-4 w-4" data-id="element-100" data-mp="18gsr4wgqnrqq" /> Mobile
        </button>
        <button type="button" onClick={() => {
        setFull(true);
        trackEvent("demo_toggle", {
          mode: "fullscreen"
        });
      }} className={btn(false)} data-id="element-101" data-mp="18ezijbmkexg3">
          <MaximizeIcon className="h-4 w-4" data-id="element-102" data-mp="20xwpq3jhjzhl" /> Full-screen
        </button>
      </div>

      <div className="grid place-items-center rounded-[clamp(1rem,1.5vw,1.75rem)] border border-line bg-ink-2 p-[clamp(0.75rem,2vw,2.5rem)]" data-id="element-103" data-mp="1w6eqbjx426yq">
        <motion.div layout transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className={`overflow-hidden border border-line-strong bg-black shadow-2xl ${mode === "desktop" ? "w-full rounded-xl" : "w-[min(390px,100%)] rounded-[2.25rem] border-[6px] border-ink-4"}`} data-id="element-104" data-mp="3qfaf3jwp61su">
          {mode === "desktop" && <div className="flex items-center gap-2 border-b border-line bg-ink-3 px-4 py-3" aria-hidden data-id="element-105" data-mp="36pq9eibwp9p1">
              <span className="h-2.5 w-2.5 rounded-full bg-white/20" data-id="element-106" data-mp="3bqxjwp5fomze" />
              <span className="h-2.5 w-2.5 rounded-full bg-white/20" data-id="element-107" data-mp="2xqmpjc4x0q9h" />
              <span className="h-2.5 w-2.5 rounded-full bg-white/20" data-id="element-108" data-mp="2xsfwksjfxci0" />
              <span className="ml-3 flex-1 truncate rounded-md bg-ink-4 px-3 py-1 font-mono text-xs text-muted" data-id="element-109" data-mp="32pptsud2msge">your-restaurant.com</span>
            </div>}
          <div className={`overflow-y-auto ${mode === "desktop" ? "h-[clamp(420px,62vh,900px)]" : "h-[min(720px,70vh)]"}`} data-id="element-110" data-mp="10y302l1sojg8">
            <DemoSite compact={mode === "mobile"} data-id="element-111" data-mp="1b2jcf4g2fifa" />
          </div>
        </motion.div>
      </div>

      <AnimatePresence data-id="element-112" data-mp="163yh9jfo7oxp">
        {full && <motion.div role="dialog" aria-modal="true" aria-label="Full-screen demo" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed inset-0 z-[90] overflow-y-auto bg-black" data-id="element-113" data-mp="1ju1vbn4eccc2">
            <button type="button" onClick={() => setFull(false)} className="fixed right-4 top-4 z-10 inline-flex min-h-[44px] items-center gap-2 rounded-full bg-fg px-4 text-[15px] font-medium text-ink" data-id="element-114" data-mp="1ov91jhqw53gm">
              <XIcon className="h-4 w-4" data-id="element-115" data-mp="8fy0kepzik5y" /> Exit full-screen
            </button>
            <DemoSite compact={false} data-id="element-116" data-mp="4dtdjyu1klsa" />
          </motion.div>}
      </AnimatePresence>
    </div>;
}